import ReactGA from "react-ga4";

export default function downloadFile(url: string, name: string) {
    try {
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", name);
        document.body.appendChild(link);

        ReactGA.event({
            category: "Download",
            action: "download",
            label: name,
            value: 0
        });

        link.click();
        document.body.removeChild(link);
    } catch (error: any) {
        console.error(error.message);
    }
}
